// extracted by mini-css-extract-plugin
export var content = "_85-3";
export var list = "_85-4";
export var settingsContent = "_85-7";
export var settingsPanel = "_85-8";
export var state = "_85-6";
export var triggerBadge = "_85-2";
export var triggerButton = "_85-1";
export var triggerShell = "_85-0";
export var unreadDot = "_85-5";